<div class="confirmation-dialog-header">
    <h2 rds-dialog-header>
        <rds-icon namespace="filled" icon="warning_triangle"/>{{ data.title }}
    </h2>
    <div
        class="close-icon"
        rds-dialog-icon-placeholder
        *ngIf="
            data.type === 'info' ||
            data.type === 'confirm' ||
            data.type === 'warning'
        "
    >
        <button
            rds-icon-button
            size="m"
            [rds-dialog-close]="null"
            (click)="closeDialog('')"
        >
            <rds-icon icon="close" namespace="outlined"></rds-icon>
        </button>
    </div>
</div>
<div rds-dialog-content *ngIf="!!data.body" [innerHTML]="data.body">
</div>
<div class="footer-container pt-0" rds-dialog-actions-container>
    <span class="informative-btn" *ngIf="data.data && data.type === 'info'">{{
        data.data
    }}</span>
    <div class="btn-content">
        <button
            *ngIf="data.type === 'info' || data.type === 'confirm'"
            rds-secondary-button
            [rds-dialog-close]="'no'"
            size="s"
            (click)="closeDialog('No')"
        >
            {{ data.type === 'confirm' ? 'Cancel' : 'No' }}
        </button>
        <button
            *ngIf="data.type === 'warn'"
            rds-secondary-button
            [rds-dialog-close]="'no'"
            size="s"
            (click)="closeDialog('No')"
        >
            {{ data.type === 'warn' ? 'No, go back' : 'No' }}
        </button>
         <button
            *ngIf="data.type === 'warning'"
            rds-secondary-button
            [rds-dialog-close]="'no'"
            size="s"
            (click)="closeDialog('No')"
        >
            {{ data.type === 'warning' ? 'Close' : 'No' }}
        </button>
        <button
            *ngIf="data.type === 'info' || data.type === 'confirm'"
            rds-primary-button
            [rds-dialog-close]="'yes'"
            [disabled]="!!data.data"
            size="s"
            (click)="closeDialog('Yes')"
            [class.leave-project-btn]="!!data.confirmButtonText"
        >
            {{ data.confirmButtonText || (data.type === 'confirm' ? 'Confirm' : 'Yes') }}
        </button>
        <button
            *ngIf="data.type === 'warn'"
            rds-primary-button
            [rds-dialog-close]="'yes'"
            size="s"
            (click)="closeDialog('Yes')"
        >
            {{ data.type === 'warn' ? 'Yes, proceed' : 'Yes' }}
        </button>
    </div>
</div>
